export const angularFrameRoutesParams = {
  AngularFrame_Home: { state: 'new-app.home' },
  AngularFrame_FormsAndTerms: { state: 'app.fichasTermos.pf' },
  AngularFrame_VoluntaryEvents: { state: 'app.eventosVoluntarios' },
  AngularFrame_MyProfile: { state: 'app.meuUsuario' },
  AngularFrame_ProductControl: { state: 'app.controleProduto.busca' },
  AngularFrame_LifeInsurance: { state: 'app.seguros.inicio' },
  AngularFrame_AccessLevels: { state: 'app.niveisAcesso' },
  AngularFrame_DividendHistory: { state: 'app.news.proventos' },
  AngularFrame_OrderGenerator: { state: 'new-app.order-generator.index' },
  AngularFrame_ConsolidatedPortfolio: { state: 'app.consolidated-portfolio' },
  AngularFrame_Dashboard: { state: 'new-app.dashboard.visao-geral' },
  AngularFrame_Customers: { state: 'app.meusClientes.atendimentos' },
  AngularFrame_Commissions: { state: 'app.comissao.demonstrativo' },
  AngularFrame_TransactionFlow: { state: 'app.movimentacoes.deHoje' },
  AngularFrame_ShoppingCart: { state: 'app.carrinhoDeCompras.inicio' },
  AngularFrame_AvailableProducts: { state: 'app.produtosDisponiveis.fundosInvestimentos' },
  AngularFrame_Trading: { state: 'app.trading' },
  AngularFrame_ManagementAnalysis: { state: 'app.analiseGerencial.visaoGeral' },
};
